define(["require", "exports", "./analytics"], function (require, exports, analytics_1) {
    "use strict";
    exports.__esModule = true;
    exports.perspectiveCanvas = null;
    try {
        exports.perspectiveCanvas = fx.canvas();
    }
    catch (ex) {
        analytics_1["default"]('exception', 'no-gl-support');
    }
    function perspectiveTransform(canvas, x0, y0, x1, y1, x2, y2, x3, y3) {
        var minX = Math.min(x0, x1, x2, x3);
        var minY = Math.min(y0, y1, y2, y3);
        var maxX = Math.max(x0, x1, x2, x3);
        var maxY = Math.max(y0, y1, y2, y3);
        var width = maxX - minX;
        var height = maxY - minY;
        if (exports.perspectiveCanvas) {
            var texture = exports.perspectiveCanvas.texture(canvas);
            var diameter = Math.max(width, height);
            var factor = Math.max(1, 3000.0 / diameter);
            if (factor > 10)
                factor = 10;
            exports.perspectiveCanvas.draw(texture, width * factor, height * factor).perspective([0, 0, width * factor, 0, 0, height * factor, width * factor, height * factor], [(x0 - minX) * factor, (y0 - minY) * factor, (x1 - minX) * factor, (y1 - minY) * factor, (x2 - minX) * factor, (y2 - minY) * factor, (x3 - minX) * factor, (y3 - minY) * factor]).update();
        }
        return [minX, minY, maxX, maxY, exports.perspectiveCanvas];
    }
    exports.perspectiveTransform = perspectiveTransform;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/glfx.js
// module id = 60
// module chunks = 0